import { render, staticRenderFns } from "./edit-package-list.vue?vue&type=template&id=4fb58761&scoped=true"
import script from "./edit-package-list.vue?vue&type=script&lang=tsx"
export * from "./edit-package-list.vue?vue&type=script&lang=tsx"
import style0 from "./edit-package-list.vue?vue&type=style&index=0&id=4fb58761&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb58761",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/frontend_page_elephant/frontend_page_elephant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fb58761')) {
      api.createRecord('4fb58761', component.options)
    } else {
      api.reload('4fb58761', component.options)
    }
    module.hot.accept("./edit-package-list.vue?vue&type=template&id=4fb58761&scoped=true", function () {
      api.rerender('4fb58761', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ops/edit-package-list.vue"
export default component.exports